import type { Node } from '@xyflow/react'
import type { GraphNodeData, JsonArray, JsonObject, JsonValue } from '../types'
import { pathToId } from './jsonToGraph'

export function graphToJson(nodes: Node<GraphNodeData>[]): JsonValue {
  const byId = new Map<string, Node<GraphNodeData>>()
  for (const n of nodes) byId.set(n.id, n)

  const rootId = pathToId([])
  const root = byId.get(rootId)
  if (!root) return {}

  return build(root)

  function build(node: Node<GraphNodeData>): JsonValue {
    const data = node.data

    if (data.kind === 'value') {
      // A ref-value node serializes as { "$ref": pointer }
      const firstInline = data.inlineFields[0]
      if (firstInline?.ref) return { $ref: firstInline.ref.pointer }
      return data.scalarValue ?? null
    }

    if (data.kind === 'array') {
      const p = data.pointerFields[0]
      if (!p) return []
      return p.childIds.map((cid) => {
        const c = byId.get(cid)
        return c ? build(c) : null
      })
    }

    // object
    const obj: JsonObject = {}
    for (const f of data.inlineFields) {
      if (f.ref) {
        obj[f.key] = { $ref: f.ref.pointer }
      } else {
        obj[f.key] = f.value
      }
    }
    for (const p of data.pointerFields) {
      if (p.ref) {
        obj[p.key] = { $ref: p.ref.pointer }
        continue
      }
      if (p.childKind === 'array') {
        const arr: JsonArray = p.childIds.map((cid) => {
          const c = byId.get(cid)
          return c ? build(c) : null
        })
        obj[p.key] = arr
      } else {
        const c = byId.get(p.childIds[0])
        obj[p.key] = c ? build(c) : null
      }
    }
    return obj
  }
}
